import { __rest } from "tslib";
export const formatRequestParams = (_a) => {
    var { page, pageSize, refinements } = _a, searchConfig = __rest(_a, ["page", "pageSize", "refinements"]);
    return (Object.assign({ pageSize, skip: (page - 1) * pageSize, refinements: refinements !== null && refinements !== void 0 ? refinements : [] }, searchConfig));
};
